'use strict';

require('normalize.css/normalize.css');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/style/index.js
// module id = 347
// module chunks = 0